module.exports = __webpack_public_path__ + "teqbahn-assets/media/blog3.e96d0cbd.png";